module.exports = __webpack_public_path__ + "img/alarm.073e5be5.png";